import React, { useEffect, useState } from "react";
import {
  Card, CardBody, CardHeader, Col, Container, Row,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Pagination from "../../../components/Pagination/Pagination";
import { getAllPermissions } from "../../../services/ValitanApiService";
import { ConfirmDialog } from "primereact/confirmdialog";

const PermissionListTables = () => {
  document.title = "Permissions | Valitan";

  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationInfo, setPaginationInfo] = useState({
    pageNumber: 0,
    pageSize: 10,
    totalElements: 0,
    totalPages: 0,
  });

  useEffect(() => {
    loadPermissions(0, paginationInfo.pageSize);
  }, [paginationInfo.pageSize]);

  const loadPermissions = async (page = 0, size = 10) => {
    setLoading(true);
    try {
      const response = await getAllPermissions(page, size);
      const data = response.data.data;
      console.log("Fetched Permissions:", data);

      setPermissions(data.content || []);
      setPaginationInfo({
        totalElements: data?.total_elements || 0,
        totalPages: data?.total_pages || 1,
        pageNumber: data?.number ?? 0,
        pageSize: data?.size ?? 10,
      });

    } catch (err) {
      console.error("Error fetching permissions", err);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (paginationInfo.pageNumber < paginationInfo.totalPages - 1) {
      loadPermissions(paginationInfo.pageNumber + 1, paginationInfo.pageSize);
    }
  };

  const handlePreviousPage = () => {
    if (paginationInfo.pageNumber > 0) {
      loadPermissions(paginationInfo.pageNumber - 1, paginationInfo.pageSize);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Permission Management" breadcrumbItem="Permissions" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">All Permissions</h4>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive table-card mt-3">
                    <table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Controller</th>
                          <th>Method</th>
                          <th>Endpoint</th>
                          <th>Display Name</th>
                          <th>Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr><td colSpan="6" className="text-center">Loading...</td></tr>
                        ) : permissions.length > 0 ? (
                          permissions.map((perm, index) => (
                            <tr key={perm.id}>
                              <td>{paginationInfo.pageNumber * paginationInfo.pageSize + index + 1}</td>
                              <td>{perm.controller}</td>
                              <td>{perm.method}</td>
                              <td>{perm.end_point}</td>
                              <td>{perm.display_name}</td>
                              <td>{perm.category}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="6" className="text-center">No permissions found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    paginationInfo={paginationInfo}
                    handleNextPage={handleNextPage}
                    handlePreviousPage={handlePreviousPage}
                    onPageChange={(pageNumber, pageSize) => loadPermissions(pageNumber, pageSize)}
                    onPageSizeChange={(newPageSize) => {
                      setPaginationInfo((prev) => ({
                        ...prev,
                        pageSize: newPageSize,
                        pageNumber: 0,
                      }));
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmDialog />
      </div>
    </React.Fragment>
  );
};

export default PermissionListTables;
